import { INavItem, IClassicItem, INavQuickLinkItem } from 'mod/store/nav/interface';
import { MENU_TYPE_CLASSIC, MENU_TYPE_ROOM } from 'mod/store/nav/constant';
import { ITrackElementData, trackElement } from 'base/utils/tracker';

export const moduleId = process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 'H5 Navi V2' : 'WEB Navi V2';

export const hasSubmenu = (navItem?: INavItem) => {
    if (!navItem) {
        return false;
    }
    const classicActive = navItem.menuType === MENU_TYPE_CLASSIC && navItem.classicContent.list.length > 0;
    const roomActive = navItem.menuType === MENU_TYPE_ROOM && navItem.roomContent.list.length > 0;
    return classicActive || roomActive;
};

export type ITrackData = {
    action?: ITrackElementData['action'];
    target: string | INavItem | IClassicItem,
    relTarget: string | INavItem | IClassicItem | INavQuickLinkItem,
    position?: ITrackElementData['position'];
}

export const track = (data: ITrackData) => {
    const {
        action = 'click',
        target,
        relTarget,
        position
    } = data;

    trackElement({
        action,
        targetType: 'menu',
        target: typeof target === 'string' ? target : (target.link || target.title),
        relTarget: typeof relTarget === 'string' ? relTarget : (relTarget.link || relTarget.title),
        module: moduleId,
        position
    });
};